import { Component } from 'react';


class IteamUnitsMenuComponent extends Component {
    constructor(props) {
        super(props);

        this.pointerDownHandlerForUnitItem = this.pointerDownHandlerForUnitItem.bind(this);
    }

    componentDidMount() {
        console.log('UNITS MENU CALLING DISABLE GAME INPUTS');
        this.props.disableGameInputsCallback();
    }

    componentWillUnmount(){
        console.log('UNITS MENU CALLING ENABLE GAME INPUTS');
        this.props.enableGameInputsCallback();
    }

    pointerDownHandlerForUnitItem(index) {
        this.props.showUnitsMenu();
        this.props.navigateToChapterIndex(index);
    }

    render() {
        let units = this.props.units;

        let itemList = units.map((item, index) => {
            let classNameOfItem = 'unitsMenuItem';
            if (index === units.length - 1) {
                classNameOfItem += ' unitsItemNoBottomBorder';
            }
            
            return (<div key={index} className={classNameOfItem} >
                        <button onClick={() => this.pointerDownHandlerForUnitItem(index)}>
                            <span className='unitsMenuUnitName'>{item.unitname}{item.description.length > 0 ? ' - ' : ''}</span>
                            <span className='unitsMenuUnitDescription'>{item.description}</span>
                        </button>
                    </div>);
        });

        return (<div className='unitsMenuContainer' style={{left: `${this.props.unitsButtonLeft}px`}}>
                <div className='unitsMenuContainerBlend'></div> 
                {itemList}
                </div>);
    }
}

export default IteamUnitsMenuComponent;